import React from 'react';
import Icon from '../../../components/AppIcon';

const CertificationProgress = ({ certificationData }) => {
  const { currentLevel, progress, nextLevel, completedSteps, totalSteps } = certificationData;

  const getLevelColor = (level) => {
    switch (level) {
      case 'Bronce':
        return 'var(--color-warning)';
      case 'Plata':
        return 'var(--color-muted-foreground)';
      case 'Oro':
        return 'var(--color-accent)';
      default:
        return 'var(--color-primary)';
    }
  };

  const getLevelIcon = (level) => {
    switch (level) {
      case 'Bronce':
        return 'Award';
      case 'Plata':
        return 'Medal';
      case 'Oro':
        return 'Trophy';
      default:
        return 'Target';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Estado de Certificación
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            Progreso hacia la certificación Zero Waste
          </p>
        </div>
        <div className="flex items-center space-x-2 bg-muted px-3 py-2 rounded-md">
          <Icon 
            name={getLevelIcon(currentLevel)} 
            size={20} 
            color={getLevelColor(currentLevel)} 
          />
          <span className="font-medium text-foreground">{currentLevel}</span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">
            Progreso hacia {nextLevel}
          </span>
          <span className="text-sm text-muted-foreground">
            {completedSteps}/{totalSteps} pasos completados
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-3">
          <div 
            className="bg-primary h-3 rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="flex justify-between text-xs text-muted-foreground mt-1">
          <span>0%</span>
          <span className="font-medium">{progress}%</span>
          <span>100%</span>
        </div>
      </div>

      {/* Benefits Preview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="text-center p-4 bg-muted/50 rounded-lg">
          <Icon name="Star" size={24} color="var(--color-accent)" className="mx-auto mb-2" />
          <h3 className="font-medium text-sm text-foreground mb-1">
            Posición Destacada
          </h3>
          <p className="text-xs text-muted-foreground">
            Aparece primero en búsquedas
          </p>
        </div>
        
        <div className="text-center p-4 bg-muted/50 rounded-lg">
          <Icon name="Badge" size={24} color="var(--color-success)" className="mx-auto mb-2" />
          <h3 className="font-medium text-sm text-foreground mb-1">
            Insignia de Perfil
          </h3>
          <p className="text-xs text-muted-foreground">
            Muestra tu compromiso
          </p>
        </div>
        
        <div className="text-center p-4 bg-muted/50 rounded-lg">
          <Icon name="TrendingUp" size={24} color="var(--color-primary)" className="mx-auto mb-2" />
          <h3 className="font-medium text-sm text-foreground mb-1">
            Ranking Local
          </h3>
          <p className="text-xs text-muted-foreground">
            Mejora tu posición
          </p>
        </div>
      </div>
    </div>
  );
};

export default CertificationProgress;